module.exports = __webpack_public_path__ + "img/3s.53eaa7d1.png";